module.exports = __webpack_public_path__ + "img/legume-peas-350x184.08154146.jpg";